import { cn } from '@/core/lib/utils';

interface CalendarDateHeaderProps {
  date: Date;
  label: string;
  isOffRange: boolean;
  onDrillDown: () => void;
  eventCount: number;
}

export function CalendarDateHeader({
  label,
  isOffRange,
  onDrillDown,
  eventCount,
}: CalendarDateHeaderProps) {
  return (
    <div
      className="flex w-full items-center justify-between px-1 py-0.5"
      data-testid="calendar-date-header"
    >
      <button
        type="button"
        className={cn(
          'text-xs font-medium leading-none transition-colors hover:text-primary',
          isOffRange ? 'text-muted-foreground/50' : 'text-foreground',
        )}
        onClick={onDrillDown}
      >
        {label}
      </button>

      {eventCount > 0 && (
        <span
          className={cn(
            'inline-flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-medium leading-none',
            isOffRange ? 'bg-muted text-muted-foreground/50' : 'bg-primary/10 text-primary',
          )}
          data-testid="calendar-date-header-count"
        >
          {eventCount}
        </span>
      )}
    </div>
  );
}
